import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "recommend-edit-supplier-announce" }
const _hoisted_2 = { class: "recommend-edit-supplier-announce__check-box" }
const _hoisted_3 = { class: "month-picker-content" }
const _hoisted_4 = { class: "select-register-month-range-content" }
const _hoisted_5 = { class: "same-customer-announce-container" }
const _hoisted_6 = { class: "announce-table-container" }
const _hoisted_7 = {
  key: 0,
  class: "announce-table-container__announce-table-area announce-table-area"
}
const _hoisted_8 = { class: "announce-table-area__table-head--container" }
const _hoisted_9 = { class: "announce-table-area__table-head--row" }
const _hoisted_10 = { class: "announce-table-area__table-head--column" }
const _hoisted_11 = { class: "announce-table-area__table-body" }
const _hoisted_12 = { class: "announce-table-area__table-body--row" }
const _hoisted_13 = { class: "announce-table-area__table-body--column" }
const _hoisted_14 = { class: "announce-table-area__table-body--row" }
const _hoisted_15 = { class: "announce-table-area__table-body--column" }
const _hoisted_16 = {
  key: 1,
  class: "announce-table-area__not-selected-year-month"
}
const _hoisted_17 = { class: "announce-table-area__not-selected-year-month--warning-text" }
const _hoisted_18 = { class: "announce-table-area__not-selected-year-month--description-text" }
const _hoisted_19 = {
  key: 0,
  class: "recommend-edit-supplier-announce__button-area button-area"
}
const _hoisted_20 = { class: "announce-modal" }
const _hoisted_21 = { class: "announce-history-table-container" }
const _hoisted_22 = { class: "announce-history-table-container__announce-history-table-area announce-history-table-area" }
const _hoisted_23 = { class: "announce-history-table-area__table-head--container" }
const _hoisted_24 = { class: "announce-history-table-area__table-head--row" }
const _hoisted_25 = { class: "announce-history-table-area__table-head--column" }
const _hoisted_26 = { class: "announce-history-table-area__table-body" }
const _hoisted_27 = { class: "announce-history-table-area__table-body--row" }
const _hoisted_28 = { class: "announce-history-table-area__table-body--column" }
const _hoisted_29 = { class: "announce-history-table-area__table-body--row" }
const _hoisted_30 = { class: "announce-history-table-area__table-body--column" }
const _hoisted_31 = { class: "announce-modal__close-button-container" }

import { computed, inject, ref } from 'vue';

import { i18n } from '@/i18n';
import SvgLoader from '@/utils/SvgLoader.vue';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';
import Modal from '@/components/modal/Modal.vue';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { IAnnounce } from '@/coreDomainsModule/entities/forecast';
import { SUPPLIER_FORECAST_LENGTH } from '@/coreDomainsModule/constants';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import { IYearMonth } from '@/coreDomainsModule/date';
import { Ref } from 'vue';
import SimpleSelectInput from '@/corePagesModule/components/SimpleSelectInput/SimpleSelectInput.vue';
import { MAX_OF_DISPLAY_FORECAST_MONTH, MIN_OF_DISPLAY_FORECAST_MONTH, DEFAULT_DISPLAY_FORECAST_MONTH } from '../constants';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { key } from './useRecommendOrderStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'RecommendEditSupplierAnnounce',
  props: {
    calculatedAnnounceValues: {},
    announceHistories: {},
    receiveYearMonth: {},
    monthsRegisterSupplierForecast: {}
  },
  emits: ["change-status", "change-year-month", "change-months-register-supplier-forecast"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "37c08a84": (!receiveYearMonth.value ? `not-allowed` : `pointer`)
}))

const props = __props;

const emits = __emit;

// style variables

//変数
const t = i18n.t;
const locale = computed(() => i18n.locale);
const isSameCustomerAnnounce = ref(true);

const modalState = ref(false);

const store = inject(key);

if (!store) {
  throw new Error('store is undefined');
}

// TODO: 年月選択の警告説明用
const todayForWarning = new Date();

// monthPicker表示用の年月情報
const receiveYearMonth: Ref<IYearMonth | undefined> = ref(props.receiveYearMonth);

const monthsRegisterSupplierForecast: Ref<number> = ref(props.monthsRegisterSupplierForecast);

/**
 * モーダルを開く
 */
const openModal = () => {
  if (!receiveYearMonth.value) return;
  modalState.value = true;
};
/**
 * モーダルを閉じる
 */
const closeModal = () => {
  modalState.value = false;
};

/**
 * 客先内示と同じ値を使用するかを変更する
 * @param isChecked - 客先内示と同じ値を使用するか
 */
const onChangeStatus = (isChecked: boolean) => {
  isSameCustomerAnnounce.value = isChecked;
  emits('change-status', isChecked);
};

/**
 * 内示の受領月を選択した際の処理
 * @param selectedYearMonth - 選択された年月
 */
const onSelectedReceiveMonth = async (selectedYearMonth: IYearMonth) => {
  if (selectedYearMonth.year === 0 || selectedYearMonth.month === 0) return;
  receiveYearMonth.value = selectedYearMonth;
  emits('change-year-month', selectedYearMonth);
};

/**
 * 内示の受領月を選択した際の処理
 * @param selectedMonthsRange - 選択された出力範囲
 */
const onSelectedMonthsRegisterSupplierForecast = async (selectedMonthsRange: number) => {
  const convertedSelectedMonthsRange = Number(selectedMonthsRange);
  if (convertedSelectedMonthsRange != null) {
    monthsRegisterSupplierForecast.value = convertedSelectedMonthsRange;
  } else {
    monthsRegisterSupplierForecast.value = DEFAULT_DISPLAY_FORECAST_MONTH - 1;
  }
  emits('change-months-register-supplier-forecast', convertedSelectedMonthsRange);
};

/**
 * 表示する内示の月数の選択肢
 */
const monthsOptionsDisplayForecast = Array(MAX_OF_DISPLAY_FORECAST_MONTH - MIN_OF_DISPLAY_FORECAST_MONTH + 1)
  .fill(0)
  .map((_, i) => `${i + MIN_OF_DISPLAY_FORECAST_MONTH}`);

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(MonthPicker, {
            class: "month-picker-content__calendar",
            "model-value": receiveYearMonth.value,
            placeholder: _unref(t)('年月を選択'),
            locale: locale.value,
            "prop-format": _unref(t)('MonthPickerFormat'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (onSelectedReceiveMonth($event)))
          }, null, 8, ["model-value", "placeholder", "locale", "prop-format"])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("span", null, _toDisplayString('~'), -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SimpleSelectInput, {
            class: "select-register-month-range-content__select-box",
            index: 1,
            "model-value": `${monthsRegisterSupplierForecast.value}`,
            "custom-unit-value": 'ヶ月分',
            "select-box-name": 'SELECT_REGISTER_MONTH_RANGE',
            "prop-options": _unref(monthsOptionsDisplayForecast),
            "display-allow": false,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (onSelectedMonthsRegisterSupplierForecast(Number($event))))
          }, null, 8, ["model-value", "prop-options"])
        ]),
        _createElementVNode("span", null, _toDisplayString(_unref(t)('までを保存(詳細ページ)')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(RowCheckBox, {
            class: "same-customer-announce-container--check-box",
            "is-checked": isSameCustomerAnnounce.value,
            onChangeStatus: onChangeStatus
          }, null, 8, ["is-checked"]),
          _createVNode(_component_i18n_t, {
            class: "i18n-break",
            keypath: '客先内示と同じ(詳細ページ)',
            tag: "span"
          }, {
            newLine: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("br", null, null, -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["announce-table__modal-button-container", { 'disabled-div': !receiveYearMonth.value }])
        }, [
          _createElementVNode("span", {
            class: "announce-table__modal-button-container--text",
            onClick: openModal
          }, _toDisplayString(_unref(t)('全ての月を表示(詳細ページ)')), 1),
          _createVNode(SvgLoader, {
            class: "announce-table__show-all-announce--icon",
            name: 'doubleArrow',
            "data-testid": "`announce-table__show-all-announce--icon`",
            "button-style": 'btn-primary'
          })
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (receiveYearMonth.value != null)
          ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
              _createElementVNode("thead", _hoisted_8, [
                _createElementVNode("tr", _hoisted_9, [
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(t)('')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculatedAnnounceValues.slice(0, _unref(SUPPLIER_FORECAST_LENGTH)), (testObj, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: 'header' + index,
                      class: "announce-table-area__table-head--column"
                    }, _toDisplayString(_unref(t)('displayShortDate', {
                  year: _unref(t)(`${testObj.year}`),
                  month: _unref(t)(`${testObj.month}`),
                })), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", _hoisted_11, [
                _createElementVNode("tr", _hoisted_12, [
                  _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(t)('仕入先内示(仕入先内示項目)')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculatedAnnounceValues.slice(0, _unref(SUPPLIER_FORECAST_LENGTH)), (testObj, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: 'contents' + index,
                      class: "announce-table-area__table-body--column"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(testObj.amount.addComma()), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tr", _hoisted_14, [
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(t)('前月内示(仕入先内示項目)')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announceHistories.slice(0, _unref(SUPPLIER_FORECAST_LENGTH)), (testObj, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: 'default' + index,
                      class: "announce-table-area__table-body--column"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(testObj.amount.addComma()), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('仕入先内示項目初期値1')), 1),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('仕入先内示項目初期値2', {
              startMonth: _unref(t)(`${_unref(todayForWarning).getMonth() + 1}月`),
              endMonth: _unref(t)(
                `${_unref(DateService).getShiftedIYearMonthByMonths(_unref(todayForWarning).getFullYear(), _unref(todayForWarning).getMonth(), 3).month}月`
              ),
            })), 1)
            ]))
      ]),
      (_unref(store).state.progress === 'EditSupplierAnnounce')
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(TextButton, {
              class: "button-area__revise-button",
              "button-style": 'btn-secondary',
              "tool-tip-value": '',
              "on-click": _unref(store).reviseRecommend
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('もどる')), 1)
              ], undefined, true),
              _: 1
            }, 8, ["on-click"]),
            _createVNode(TextButton, {
              color: "primary",
              size: 'btn-md',
              disabled: !receiveYearMonth.value,
              class: "button-area__define-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).confirmSupplierAnnounce(monthsRegisterSupplierForecast.value, isSameCustomerAnnounce.value, receiveYearMonth.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('確定')), 1)
              ], undefined, true),
              _: 1
            }, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Modal, {
      "stretch-container": true,
      "modal-title": "仕入先内示(詳細ページ)",
      "border-radius": "16px",
      "modal-state": modalState.value,
      "modal-size": '2xl',
      onOutsideClick: closeModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("table", _hoisted_22, [
              _createElementVNode("thead", _hoisted_23, [
                _createElementVNode("tr", _hoisted_24, [
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_unref(t)('')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculatedAnnounceValues, (testObj, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: 'header' + index,
                      class: "announce-history-table-area__table-head--column"
                    }, _toDisplayString(_unref(t)('displayShortDate', {
                    year: _unref(t)(`${testObj.year}`),
                    month: _unref(t)(`${testObj.month}`),
                  })), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", _hoisted_26, [
                _createElementVNode("tr", _hoisted_27, [
                  _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(t)('仕入先内示(仕入先内示項目)')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculatedAnnounceValues, (testObj, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: 'contents' + index,
                      class: "announce-history-table-area__table-body--column"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(testObj.amount.addComma()), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tr", _hoisted_29, [
                  _createElementVNode("td", _hoisted_30, _toDisplayString(_unref(t)('前月内示(仕入先内示項目)')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announceHistories, (testObj, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: 'default' + index,
                      class: "announce-history-table-area__table-body--column"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(testObj.amount.addComma()), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(TextButton, {
              class: "announce-modal__close-button",
              "button-style": 'btn-cancel',
              size: 'btn-md',
              "on-click": closeModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('閉じる')), 1)
              ], undefined, true),
              _: 1
            })
          ])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["modal-state"])
  ], 64))
}
}

})